export var HIGHLIGHT_PRE_TAG = '__aa-highlight__';
export var HIGHLIGHT_POST_TAG = '__/aa-highlight__';


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-preset-algolia/dist/esm/constants/index.js
// module id = 20
// module chunks = 0